import React from "react"
import IconButton from "../IconButton"

interface TitleProps {
  isLoadingAction?: boolean
  onClickAction?: () => void
  title: string
  leftIcon: React.ReactNode
}

const Title = ({ isLoadingAction, onClickAction, title, leftIcon }: TitleProps) => {
  return (
    <div className="flex w-full justify-between items-center mb-4">
      <h3 className="text-xl font-semibold">{title}</h3>
      {onClickAction && (
        <div className={"items-center font-semibold space-x-6"}>
          <IconButton isLoading={isLoadingAction} onClick={onClickAction} leftIcon={leftIcon}>
            {title}
          </IconButton>
        </div>
      )}
    </div>
  )
}

export default Title
